import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Container,
  Typography,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Checkbox,
  FormControlLabel,
  Modal,
  Tooltip,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { ReservationFormAxios, getReserves } from "../api/dashboard";
import { useAuth } from "../context/AuthContext";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
const ReservationForm = ({ refetchAlojamiento }) => {
  const [arrival, setArrival] = useState("");
  const [departure, setDeparture] = useState("");
  const [roomNumber, setRoomNumber] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [numberOfGuests, setNumberOfGuests] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [señado, setSeñado] = useState(0);
  const [dniOrRut, setDniOrRut] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [origin, setOrigin] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [specialRequests, setSpecialRequests] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(true);
  const [availableRooms, setAvailableRooms] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [copied, setCopied] = useState(false);
  const { user } = useAuth();
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [loadingRooms, setLoadingRooms] = useState(false);
  const [employeeName, setEmployeeName] = useState("");
  const [fullOcupacion, setFullOcupacion] = useState(false);
  const [precioFullOcupacion, setPrecioFullOcupacion] = useState("");
  const [fullDisponibility, setFullDisponibility] = useState(false);

  const resetForm = () => {
    setArrival("");
    setDeparture("");
    setRoomNumber("");
    setTotalAmount("");
    setCustomerName("");
    setNumberOfGuests(2);
    setPaymentMethod("");
    setSeñado(0);
    setDniOrRut("");
    setPhoneNumber("");
    setEmail("");
    setOrigin("");
    setPaymentStatus("");
    setSpecialRequests("");
    setAcceptTerms(true);
    setSelectedRoomId(null);
    setSelectedUnitId(null);
    setSelectedRoomObject(null);
  };
  const rooms = user.rooms || [];
  const pricesRules = user.incrementFactors[0] || [];
  const propertyId = user.propertyId || 0;

  const employes = user.employes; // Si en el futuro hay varios empleados, cámbialo

  const [selectedRoomObject, setSelectedRoomObject] = useState(null);

  const handleGuestChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!selectedRoomObject) return;

    if (selectedRoomObject.type === "private") {
      const max = selectedRoomObject.maxGuests || 1;
      if (value <= max) setNumberOfGuests(value);
    } else if (selectedRoomObject.type === "shared") {
      const available = selectedRoomObject.availability?.length || 0;
      if (value <= available) setNumberOfGuests(value);
    }
  };

  useEffect(() => {
    if (!selectedRoomObject) return;

    if (selectedRoomObject.type === "private") {
      const base = Number(selectedRoomObject.pricePerGuest) || 0;

      // Determinar el mayor índice en pricesRules
      const availableLevels = Object.keys(pricesRules).map(Number);
      const maxLevel = Math.max(...availableLevels);

      // Usar el factor correspondiente o el del último nivel disponible
      const level = numberOfGuests > maxLevel ? maxLevel : numberOfGuests;
      const factor = Number(pricesRules[level]) || 1;

      const total = Math.round(base * factor);
      setTotalAmount(total);
    } else {
      // Compartidas: usar precio base sin incremento
      setTotalAmount(selectedRoomObject.pricePerGuest || "");
    }
  }, [selectedRoomObject, numberOfGuests, pricesRules]);
  const isFormValid =
    arrival &&
    departure &&
    customerName &&
    dniOrRut &&
    phoneNumber &&
    origin &&
    employeeName &&
    ((!fullOcupacion &&
      roomNumber &&
      numberOfGuests > 0 &&
      totalAmount &&
      !isNaN(Number(totalAmount))) ||
      (fullOcupacion &&
        precioFullOcupacion &&
        !isNaN(Number(precioFullOcupacion))));

  const handleRoomChange = (e) => {
    const selectedName = e.target.value;
    const selectedRoom = availableRooms.find((r) => r.name === selectedName);

    if (selectedRoom) {
      setRoomNumber(selectedRoom.name);
      setSelectedRoomId(selectedRoom.roomId);
      setSelectedRoomObject(selectedRoom); // esto actualiza el useEffe ct
      setNumberOfGuests(1);
    }
  };

  const fetchAvailableRooms = async (start, end) => {
    console.log("📅 Ejecutando fetchAvailableRooms...");
    console.log("⏱️ Fechas recibidas:", { start, end });

    if (!start || !end) {
      console.warn("⚠️ Fechas inválidas: falta una de las dos.");
      return;
    }

    if (new Date(start) >= new Date(end)) {
      console.warn(
        "⚠️ La fecha de ingreso es igual o posterior a la de salida."
      );
      return;
    }

    if (!user || !user.propertyId) {
      console.warn("⚠️ Usuario o propertyId no definido:", user);
      return;
    }

    setLoadingRooms(true); // ⏳ empieza el loading

    try {
      const res = await getReserves({
        startDate: start,
        endDate: end,
        propertyId: user.propertyId,
      });

      console.log("📦 Respuesta de getReserves:", res.data.data);

      if (res.status === 200 && Array.isArray(res.data.data)) {
        const disponibles = res.data.data.filter(
          (room) =>
            Array.isArray(room.availability) && room.availability.length > 0
        );

        console.log("✅ Habitaciones con disponibilidad:", disponibles);
        setAvailableRooms(disponibles);

        // ✅ Acá seteás el flag
        setFullDisponibility(!!res.data.fullDisponibility);
        console.log(
          "🏁 Flag de disponibilidad total:",
          res.data.fullDisponibility
        );
      } else {
        console.warn("⚠️ Respuesta inesperada:", res.status, res.data);
      }
    } catch (error) {
      console.error("❌ Error al obtener habitaciones:", error);
    } finally {
      setLoadingRooms(false); // ✅ termina el loading
    }
  };

  const handleCloseAndRefetch = () => {
    setModalOpen(false);
    setTimeout(() => {
      refetchAlojamiento(); // esta función viene del padre y actualiza los datos
    }, 300); // puedes ajustar este delay si es necesario
  };

  useEffect(() => {
    if (arrival && departure) fetchAvailableRooms(arrival, departure);
  }, [arrival, departure]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const total = fullOcupacion
      ? Number(precioFullOcupacion)
      : Number(totalAmount);

    const required = fullOcupacion
      ? [employeeName, customerName, dniOrRut, total, arrival, departure]
      : [
          employeeName,
          customerName,
          numberOfGuests,
          roomNumber,
          dniOrRut,
          total,
          arrival,
          departure,
        ];

    if (required.some((f) => !f)) {
      setErrorMessage("Completa los campos obligatorios.");
      setLoading(false);
      return;
    }

    // 🧠 Preparar unitIds dinámicamente
    let unitIds = [];

    if (fullOcupacion) {
      unitIds = availableRooms.flatMap((room) => {
        if (room.type === "shared") {
          return room.availability || [];
        } else {
          return [room.unitId];
        }
      });
    } else if (selectedRoomObject) {
      if (selectedRoomObject.type === "private") {
        unitIds = [selectedRoomObject.unitId];
      } else if (selectedRoomObject.type === "shared") {
        // Selecciona X camas según numberOfGuests
        unitIds = selectedRoomObject.availability.slice(0, numberOfGuests);
      }
    }

    const data = {
      employeeName,
      paymentMethod,
      customerName,
      numberOfGuests,
      roomNumber,
      dniOrRut,
      phoneNumber,
      email,
      origin,
      paymentStatus,
      totalAmount: total,
      arrival,
      departure,
      specialRequests,
      señado,
      propertyId,
      roomId: selectedRoomId,
      unitIds,
      fullOcupacion,
    };

    console.log("📤 Datos enviados al backend:", data);

    try {
      const res = await ReservationFormAxios(data);
      if (res.status === 200 && res.data?.reservationId) {
        setSuccessMessage("Reserva registrada.");
        setAlertOpen(true);
        const reservationId = res.data.reservationId;
        const link = `${user.linkUrl}/#/completepay?reservationId=${reservationId}`;
        setGeneratedLink(link);
        setModalOpen(true);
        setCopied(false);
        resetForm();
        refetchAlojamiento();
      } else {
        setErrorMessage("Error: no se recibió un ID válido.");
      }
    } catch (err) {
      console.error("❌ Error al enviar la reserva:", err);
      setErrorMessage("No se pudo guardar la reserva.");
    } finally {
      setLoading(false);
    }
  };

  if (!user || !user.rooms) return <CircularProgress />;

  // Si el usuario aún no está cargado, muestra un spinner
  if (!user) return <CircularProgress />;
  return (
    <Box
      sx={{
        bgcolor: "rgba(245, 240, 244, 0.42)", // Violeta Ubika suave
        p: { xs: 2, sm: 4 },
        borderRadius: 4,
        minHeight: "100vh",
        backdropFilter: "blur(3px)",
      }}
    >
    <Typography
  variant="h4"
  align="center"
  fontWeight="bold"
  gutterBottom
  color="primary"
  sx={{ mb: 4 }}
>
  🌈 Reserva Manual 🌈 👀💼
</Typography>


      <Snackbar
        open={alertOpen}
        autoHideDuration={4000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert severity="success" sx={{ borderRadius: 2 }}>
          {successMessage}
        </Alert>
      </Snackbar>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Fechas */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Ingreso"
              type="date"
              size="small"
              fullWidth
              value={arrival}
              onChange={(e) => setArrival(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Salida"
              type="date"
              size="small"
              fullWidth
              value={departure}
              onChange={(e) => setDeparture(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>

          {/* Full Ocupación */}
          {fullDisponibility && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={fullOcupacion}
                    onChange={(e) => setFullOcupacion(e.target.checked)}
                    color="secondary"
                  />
                }
                label="Reservar todas las habitaciones (full ocupación)"
              />
            </Grid>
          )}

          {fullOcupacion && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Total cobrado por full ocupación"
                value={precioFullOcupacion}
                onChange={(e) => setPrecioFullOcupacion(e.target.value)}
                size="small"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="Ingresa el total cobrado por bloquear todas las habitaciones">
                        <HelpOutlineIcon color="action" />
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}

          {!fullOcupacion && (
            <>
              <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Habitación</InputLabel>
                  <Select
                    value={roomNumber}
                    onChange={handleRoomChange}
                    required
                    label="Habitación"
                    disabled={loadingRooms}
                  >
                    {availableRooms.map((room) => (
                      <MenuItem
                        key={`${room.roomId}-${room.unitId}`}
                        value={room.name}
                      >
                        {room.type === "shared"
                          ? `${room.name} (${room.availability.length} camas)`
                          : room.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {loadingRooms && (
                  <CircularProgress
                    size={20}
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: 12,
                      mt: "-10px",
                    }}
                  />
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Tarifa por noche"
                  value={totalAmount}
                  onChange={(e) => setTotalAmount(e.target.value)}
                  size="small"
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Valor de la tarifa por noche">
                          <HelpOutlineIcon color="action" />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Número de huéspedes"
                  type="number"
                  fullWidth
                  size="small"
                  value={numberOfGuests}
                  onChange={handleGuestChange}
                  InputProps={{ inputProps: { min: 1, max: 10 } }}
                />
              </Grid>
            </>
          )}

          {/* Datos del cliente */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nombre del Cliente"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              size="small"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="DNI o RUT"
              value={dniOrRut}
              onChange={(e) => setDniOrRut(e.target.value)}
              size="small"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Teléfono"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              size="small"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small" required>
              <InputLabel>Empleado</InputLabel>
              <Select
                label="Empleado"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
              >
                {employes.map((emp) => (
                  <MenuItem key={emp} value={emp}>
                    {emp}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Origen</InputLabel>
              <Select
                label="Origen"
                value={origin}
                onChange={(e) => setOrigin(e.target.value)}
                required
              >
                <MenuItem value="whatsapp">WhatsApp</MenuItem>
                <MenuItem value="presencial">Presencial</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Solicitudes Especiales"
              value={specialRequests}
              onChange={(e) => setSpecialRequests(e.target.value)}
              size="small"
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                py: 1.5,
                fontWeight: "bold",
                borderRadius: 3,
                bgcolor: "primary.main",
                ":hover": { bgcolor: "primary.dark" },
              }}
              disabled={!isFormValid}
            >
              Confirmar Reserva
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default ReservationForm;
